import { facilitiesTranslation } from "../utils/facilitiesTranslation";

export const CAMPAIGN_HOTEL_FACILITY_CATEGORIES = [
  { id: "general", labelHe: "כללי" },
  { id: "pool", labelHe: "בריכה" },
  { id: "spa", labelHe: "ספא וכושר" },
  { id: "dining", labelHe: "אוכל" },
  { id: "family", labelHe: "משפחה" },
  { id: "accessibility", labelHe: "נגישות" },
  { id: "business", labelHe: "עסקים" },
  { id: "transport", labelHe: "תחבורה וחניה" },
  { id: "kosher", labelHe: "כשרות" },
  { id: "security", labelHe: "אבטחה" },
];

export const CAMPAIGN_ROOM_FACILITY_CATEGORIES = [
  { id: "general", labelHe: "כללי" },
  { id: "sleep", labelHe: "מיטה ושינה" },
  { id: "view", labelHe: "נוף ומרפסת" },
  { id: "bathroom", labelHe: "חדר רחצה" },
  { id: "kitchen", labelHe: "מטבח ומיניבר" },
  { id: "entertainment", labelHe: "בידור" },
  { id: "comfort", labelHe: "נוחות" },
  { id: "accessibility", labelHe: "נגישות" },
  { id: "connecting", labelHe: "חיבור" },
];

function slugId(nameEn) {
  return String(nameEn || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

function hebrewFor(nameEn, fallbackHe) {
  return facilitiesTranslation[nameEn] || fallbackHe || nameEn;
}

function rows(category, items) {
  return items.map(([nameEn, nameHe]) => ({
    id: slugId(nameEn),
    nameEn,
    nameHe: hebrewFor(nameEn, nameHe),
    category,
  }));
}

/** Hotel-level amenities. Seeds existing FE translation keys, then expands to a full ops catalog. */
export const CAMPAIGN_HOTEL_FACILITIES = [
  ...rows("general", [
    ["Wifi", "WiFi"],
    ["Free Wifi", "WiFi חינם"],
    ["Internet access", "גישה לאינטרנט"],
    ["24 Hour Front Desk", "קבלה 24 שעות"],
    ["Air conditioning", "מיזוג אוויר"],
    ["Lifts", "מעליות"],
    ["Luggage storage", "אחסון מזוודות"],
    ["Housekeeping", "ניקיון"],
    ["Laundry Service", "שירות כביסה"],
    ["Dry cleaning service", "שירות ניקוי יבש"],
    ["Non smoking rooms", "חדרים ללא עישון"],
    ["Smoking area", "אזור עישון"],
    ["Terrace", "טרסה"],
    ["Garden", "גן"],
    ["Concierge", "קונסיירז׳"],
    ["Newspapers", "עיתונים"],
    ["ATM on site", "כספומט במלון"],
    ["Gift shop", "חנות מזכרות"],
    ["Currency exchange", "החלפת מטבע"],
    ["Heating", "חימום"],
    ["Soundproof rooms", "חדרים אטומים לרעש"],
    ["Express check-in / check-out", "צ׳ק-אין / צ׳ק-אאוט מהיר"],
    ["Wake-Up service", "שירות השכמה"],
    ["Pets allowed", "חיות מחמד מותרות"],
    ["Designated smoking area", "אזור עישון ייעודי"],
  ]),
  ...rows("pool", [
    ["Swimming pool", "בריכת שחייה"],
    ["Outdoor pool", "בריכה חיצונית"],
    ["Indoor pool", "בריכה מקורה"],
    ["Salt water pool", "בריכת מי מלח"],
    ["Kids pool", "בריכת ילדים"],
    ["Infinity pool", "בריכת אינפיניטי"],
    ["Rooftop pool", "בריכת גג"],
    ["Heated pool", "בריכה מחוממת"],
    ["Pool bar", "בר בריכה"],
    ["Pool towels", "מגבות בריכה"],
    ["Sun loungers", "מיטות שיזוף"],
    ["Beach nearby", "חוף קרוב"],
    ["Private beach", "חוף פרטי"],
    ["Water slide", "מגלשת מים"],
  ]),
  ...rows("spa", [
    ["Spa", "ספא"],
    ["Fitness Center", "מרכז כושר"],
    ["Gymnasium", "מכון כושר"],
    ["Sauna", "סאונה"],
    ["Hammam", "חמאם"],
    ["Hot tub", "ג׳קוזי"],
    ["Massage", "עיסוי"],
    ["Steam room", "חדר אדים"],
    ["Beauty salon", "מכון יופי"],
    ["Yoga classes", "שיעורי יוגה"],
    ["Solarium", "סולריום"],
    ["Wellness center", "מרכז וולנס"],
  ]),
  ...rows("dining", [
    ["Restaurant(s)", "מסעדה/ות"],
    ["Bars", "ברים"],
    ["Room Service", "שירות חדרים"],
    ["Lunch", "ארוחת צהריים"],
    ["Breakfast buffet", "בופה בוקר"],
    ["Breakfast in the room", "ארוחת בוקר בחדר"],
    ["Coffee", "קפה"],
    ["Cafe", "בית קפה"],
    ["Snack bar", "חטיפים / סנק בר"],
    ["BBQ facilities", "מתקני ברביקיו"],
    ["Special diet menus", "תפריטים דיאטטיים"],
    ["Packed lunches", "ארוחות ארוזות"],
    ["Kids meals", "ארוחות ילדים"],
    ["All inclusive", "הכל כלול"],
  ]),
  ...rows("family", [
    ["Family rooms", "חדרים למשפחה"],
    ["Games room", "חדר משחקים"],
    ["Mini Golf", "מיני גולף"],
    ["Playground", "גינת משחקים"],
    ["Babysitting", "בייביסיטר"],
    ["Kids club", "מועדון ילדים"],
    ["Cots available", "עריסות זמינות"],
    ["Board games", "משחקי קופסה"],
    ["Evening entertainment", "בידור ערב"],
    ["Live music", "מוזיקה חיה"],
    ["Bicycle rental", "השכרת אופניים"],
    ["Tennis court", "מגרש טניס"],
    ["Table tennis", "טניס שולחן"],
    ["Billiard", "ביליארד"],
  ]),
  ...rows("accessibility", [
    ["Wheelchair accessible", "נגיש לכיסא גלגלים"],
    ["Accessible rooms", "חדרים נגישים"],
    ["Accessible parking", "חניה נגישה"],
    ["Accessible bathroom", "שירותים נגישים"],
    ["Elevator access", "גישה במעלית"],
    ["Visual aids", "עזרים חזותיים"],
    ["Hearing induction loop", "לולאת השראה לשמיעה"],
    ["Lowered sink", "כיור מונמך"],
    ["Roll-in shower", "מקלחת נגישה"],
  ]),
  ...rows("business", [
    ["Meeting rooms", "חדרי ישיבות"],
    ["Business center", "מרכז עסקים"],
    ["Conference facilities", "מתקני כנסים"],
    ["Fax / photocopying", "פקס / צילום"],
    ["Coworking space", "חלל עבודה"],
    ["Projector", "מקרן"],
    ["Banquet hall", "אולם אירועים"],
  ]),
  ...rows("transport", [
    ["Parking", "חניה"],
    ["Free car parking", "חניה חינם"],
    ["Private parking", "חניה פרטית"],
    ["Valet parking", "חניון שירות"],
    ["Electric vehicle charging", "טעינת רכב חשמלי"],
    ["Shuttle service", "שירות הסעות"],
    ["Airport shuttle", "הסעה לשדה תעופה"],
    ["Car hire", "השכרת רכב"],
    ["Taxi service", "שירות מוניות"],
    ["Bicycle parking", "חניית אופניים"],
  ]),
  ...rows("kosher", [
    ["Kosher kitchen", "מטבח כשר"],
    ["Kosher restaurant", "מסעדה כשרה"],
    ["Kosher breakfast", "ארוחת בוקר כשרה"],
    ["Shabbat elevator", "מעלית שבת"],
    ["Shabbat key", "מפתח שבת"],
    ["Synagogue nearby", "בית כנסת בקרבת מקום"],
    ["Kosher supervision", "השגחה כשרה"],
    ["Separate meat / dairy", "הפרדת בשר וחלב"],
    ["Shabbat meals", "סעודות שבת"],
  ]),
  ...rows("security", [
    ["24H. Security", "אבטחה 24 שעות"],
    ["Security Features", "אמצעי אבטחה"],
    ["Smoke detector", "גלאי עשן"],
    ["First aid", "עזרה ראשונה"],
    ["CCTV in common areas", "מצלמות באזורים ציבוריים"],
    ["Fire extinguishers", "מטפי כיבוי"],
    ["Safe deposit box", "כספת בקבלה"],
    ["Key card access", "כניסה בכרטיס"],
    ["Security alarm", "אזעקה"],
  ]),
];

/** Room-level amenities. Seeds existing FE translation + sample RoomFacility names. */
export const CAMPAIGN_ROOM_FACILITIES = [
  ...rows("general", [
    ["Air conditioning", "מיזוג אוויר"],
    ["Heating", "חימום"],
    ["Wifi", "WiFi"],
    ["Internet access", "גישה לאינטרנט"],
    ["Safe", "כספת"],
    ["Telephone", "טלפון"],
    ["Desk", "שולחן כתיבה"],
    ["Iron and board", "מגהץ ולוח גיהוץ"],
    ["Wake-Up service", "שירות השכמה"],
    ["Housekeeping", "ניקיון"],
    ["Soundproofing", "בידוד רעש"],
    ["Carpeted", "מרוצף שטיחים"],
    ["Hardwood / parquet", "פרקט"],
    ["Wardrobe", "ארון בגדים"],
    ["Clothes rack", "מתלה בגדים"],
    ["Blackout curtains", "וילונות האפלה"],
  ]),
  ...rows("sleep", [
    ["King bed", "מיטת קינג"],
    ["Queen bed", "מיטת קווין"],
    ["Twin beds", "מיטות יחיד"],
    ["Sofa bed", "ספה נפתחת"],
    ["Extra bed", "מיטה נוספת"],
    ["Cot", "עריסה"],
    ["Hypoallergenic bedding", "מצעים היפואלרגניים"],
    ["Premium linens", "מצעים משודרגים"],
    ["Pillow menu", "תפריט כריות"],
    ["Electric blanket", "שמיכה חשמלית"],
  ]),
  ...rows("view", [
    ["Balcony", "מרפסת"],
    ["Terrace", "טרסה"],
    ["Sea view", "נוף לים"],
    ["City view", "נוף לעיר"],
    ["Garden view", "נוף לגן"],
    ["Pool view", "נוף לבריכה"],
    ["Mountain view", "נוף להרים"],
    ["Lake view", "נוף לאגם"],
    ["Landmark view", "נוף לאתר"],
    ["Patio", "פטיו"],
  ]),
  ...rows("bathroom", [
    ["Bathroom", "חדר אמבטיה"],
    ["Private bathroom", "חדר רחצה פרטי"],
    ["Shower", "מקלחת"],
    ["Bathtub", "אמבטיה"],
    ["WC", "שירותים"],
    ["Hairdryer", "מייבש שיער"],
    ["Towels", "מגבות"],
    ["Sink", "כיור"],
    ["Bathrobe", "חלוק רחצה"],
    ["Slippers", "נעלי בית"],
    ["Toiletries", "מוצרי רחצה"],
    ["Bidet", "בידה"],
    ["Walk-in shower", "מקלחת walk-in"],
    ["Rain shower", "מקלחת גשם"],
    ["Makeup mirror", "מראת איפור"],
  ]),
  ...rows("kitchen", [
    ["Minibar", "מיני בר"],
    ["Kitchenette", "מטבחון"],
    ["Microwave", "מיקרוגל"],
    ["Coffee", "קפה"],
    ["Electric kettle", "קומקום חשמלי"],
    ["Refrigerator", "מקרר"],
    ["Stovetop", "כיריים"],
    ["Oven", "תנור"],
    ["Dishwasher", "מדיח כלים"],
    ["Dining table", "שולחן אוכל"],
    ["Kitchenware", "כלי מטבח"],
    ["Toaster", "טוסטר"],
    ["Water", "מים"],
    ["Free bottled water", "מים מינרליים"],
    ["Tea / coffee maker", "מכונת קפה / תה"],
  ]),
  ...rows("entertainment", [
    ["TV", "טלוויזיה"],
    ["Flat-screen TV", "טלוויזיה שטוחה"],
    ["Satellite channels", "ערוצי לוויין"],
    ["Cable channels", "ערוצי כבלים"],
    ["Streaming service", "שירות סטרימינג"],
    ["Radio", "רדיו"],
    ["Bluetooth speaker", "רמקול בלוטות׳"],
    ["Game console", "קונסולת משחקים"],
    ["DVD player", "נגן DVD"],
  ]),
  ...rows("comfort", [
    ["Cleaning", "ניקיון"],
    ["Smoke detector", "גלאי עשן"],
    ["Washing Machine", "מכונת כביסה"],
    ["Dryer", "מייבש כביסה"],
    ["Seating area", "פינת ישיבה"],
    ["Sofa", "ספה"],
    ["Armchair", "כורסה"],
    ["Fan", "מאוורר"],
    ["Mosquito net", "כילת יתושים"],
    ["In-room safe", "כספת בחדר"],
    ["Alarm clock", "שעון מעורר"],
    ["USB charging", "טעינת USB"],
    ["Work space", "פינת עבודה"],
    ["Laptop safe", "כספת למחשב"],
  ]),
  ...rows("accessibility", [
    ["Wheelchair accessible", "נגיש לכיסא גלגלים"],
    ["Roll-in shower", "מקלחת נגישה"],
    ["Grab rails", "מאחזי יד"],
    ["Lowered sink", "כיור מונמך"],
    ["Emergency cord", "כבל מצוקה"],
    ["Accessible toilet", "שירותים נגישים"],
    ["Hearing accessible", "נגיש לשמיעה"],
  ]),
  ...rows("connecting", [
    ["Connecting rooms", "חדרים מחוברים"],
    ["Interconnecting door", "דלת חיבור"],
    ["Family connecting", "חיבור למשפחה"],
    ["Adjoining rooms", "חדרים סמוכים"],
    ["Suite living room", "סלון בסוויטה"],
  ]),
];

function uniqueById(list) {
  const seen = new Set();
  return list.filter((row) => {
    if (!row?.id || seen.has(row.id)) return false;
    seen.add(row.id);
    return true;
  });
}

export const CAMPAIGN_HOTEL_FACILITY_CATALOG = uniqueById(CAMPAIGN_HOTEL_FACILITIES);
export const CAMPAIGN_ROOM_FACILITY_CATALOG = uniqueById(CAMPAIGN_ROOM_FACILITIES);

export function campaignFacilityCatalog(scope) {
  return scope === "room" ? CAMPAIGN_ROOM_FACILITY_CATALOG : CAMPAIGN_HOTEL_FACILITY_CATALOG;
}

export function campaignFacilityCategories(scope) {
  return scope === "room" ? CAMPAIGN_ROOM_FACILITY_CATEGORIES : CAMPAIGN_HOTEL_FACILITY_CATEGORIES;
}

export function campaignFacilityById(id, scope) {
  const key = String(id || "").trim();
  if (!key) return null;
  const lower = key.toLowerCase();
  return (
    campaignFacilityCatalog(scope).find(
      (row) =>
        row.id === key ||
        row.id === lower ||
        row.nameEn.toLowerCase() === lower,
    ) || null
  );
}

export function resolveCampaignFacilities(ids, scope) {
  const list = Array.isArray(ids) ? ids : [];
  const seen = new Set();
  const out = [];
  for (const raw of list) {
    const id = typeof raw === "object" ? raw?.id : raw;
    const hit = campaignFacilityById(id, scope);
    if (!hit || seen.has(hit.id)) continue;
    seen.add(hit.id);
    out.push({
      id: hit.id,
      nameHe: hit.nameHe,
      nameEn: hit.nameEn,
      category: hit.category,
    });
  }
  return out;
}

export function normalizeCampaignFacilityRecords(raw, scope) {
  if (!Array.isArray(raw) || !raw.length) return [];
  const ids = raw.map((row) => (typeof row === "string" ? row : row?.id || row?.nameEn));
  const resolved = resolveCampaignFacilities(ids, scope);
  if (resolved.length) return resolved;
  return raw
    .map((row) => {
      if (!row || typeof row !== "object") return null;
      const nameEn = String(row.nameEn || row.facilityname || row.name || "").trim();
      const id = String(row.id || slugId(nameEn)).trim();
      if (!id && !nameEn) return null;
      return {
        id: id || slugId(nameEn),
        nameEn: nameEn || id,
        nameHe: String(row.nameHe || hebrewFor(nameEn) || nameEn).trim(),
        category: String(row.category || "general").trim() || "general",
      };
    })
    .filter(Boolean);
}

export function campaignFacilitiesToProfileHotel(list) {
  return normalizeCampaignFacilityRecords(list, "hotel").map((row) => ({
    facilityname: row.nameEn,
    facilitytype: "HotelFacility",
    nameHe: row.nameHe,
    id: row.id,
  }));
}

export function campaignFacilitiesToRoomNames(list) {
  return normalizeCampaignFacilityRecords(list, "room").map((row) => row.nameEn);
}
